var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7072 18.4418L21.0164 9.81016C20.3442 8.23006 19.3419 7.33389 18.1981 7.27493C17.0661 7.21597 15.9695 8.00602 15.1323 9.51536L12.8918 13.5364C12.4202 14.3854 11.748 14.8924 11.0169 14.9514C10.274 15.0221 9.53114 14.633 8.92976 13.8666L8.67034 13.5364C7.83313 12.4869 6.79545 11.9799 5.7342 12.086C4.67294 12.1921 3.76497 12.9232 3.16359 14.1142L1.12362 18.1823C0.392528 19.6563 0.463279 21.3661 1.32408 22.7575C2.18488 24.149 3.68243 24.9862 5.32148 24.9862H20.3678C21.9479 24.9862 23.4219 24.1961 24.2945 22.8755C25.1906 21.5548 25.3321 19.8921 24.7072 18.4418Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96193 8.49046C9.16314 8.49046 10.9475 6.70604 10.9475 4.50484C10.9475 2.30365 9.16314 0.519226 6.96193 0.519226C4.76074 0.519226 2.97632 2.30365 2.97632 4.50484C2.97632 6.70604 4.76074 8.49046 6.96193 8.49046Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLogoIcon);
export default __webpack_public_path__ + "static/media/imageLogoIcon.40147cf11c200d41797f08ba740d14a9.svg";
export { ForwardRef as ReactComponent };